import React, { useEffect, useState } from 'react';
import './ButonInstallAppNav.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';

const ButonInstallAppNav = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstalled, setIsInstalled] = useState(false);

    useEffect(() => {
        // Comprobar si ya está instalada
        const checkIfInstalled = () => {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
            setIsInstalled(isStandalone);
        };

        checkIfInstalled();

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            console.log('Evento beforeinstallprompt capturado con éxito');
        };

        const handleAppInstalled = () => {
            setIsInstalled(true);
            setDeferredPrompt(null);
            console.log('La aplicación fue instalada con éxito');
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    const handleInstallClick = () => {
        if (isInstalled) {
            Swal.fire({
                title: 'Aplicación ya instalada',
                text: 'El sistema ya se encuentra instalado en tu dispositivo como aplicación.',
                icon: 'info',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    Swal.fire({
                        title: '¡Instalación iniciada!',
                        text: 'La aplicación se está instalando en tu dispositivo.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setIsInstalled(true);
                }
                setDeferredPrompt(null);
            });
        } else {
            // Guía paso a paso para navegadores compatibles
            Swal.fire({
                title: 'Cómo instalar la aplicación',
                html: `
                    <div style="text-align: left; font-size: 14px; line-height: 1.6; color: #374151;">
                        <p><strong>En Computadora (Chrome / Edge / Brave):</strong></p>
                        <ul>
                            <li>Haz clic en el icono <strong>⊕ Instalar</strong> que aparece en la barra de direcciones arriba a la derecha.</li>
                            <li>O abre el menú de tres puntos (⋮) y selecciona <em>"Instalar aplicación..."</em>.</li>
                        </ul>
                        <p><strong>En Teléfono Móvil (Android / iOS):</strong></p>
                        <ul>
                            <li>Toca el menú del navegador (⋮ o Compartir) y elige <em>"Agregar a la pantalla principal"</em> o <em>"Instalar app"</em>.</li>
                        </ul>
                    </div>
                `,
                icon: 'info',
                confirmButtonText: 'Aceptar'
            });
        }
    };

    return (
        <button
            type="button"
            onClick={handleInstallClick}
            className={`btnInstall ${isInstalled ? 'installed' : ''}`}
            title={isInstalled ? "Aplicación instalada" : "Instalar aplicación en tu dispositivo"}
        >
            <FontAwesomeIcon icon={isInstalled ? faCheckCircle : faDownload} />
            <span>{isInstalled ? 'Instalada' : 'Instalar'}</span>
        </button>
    );
};

export default ButonInstallAppNav;
